<sh-page class="upload-asset-page" theme={{theme_color}}>
    <sh-pane slot='left' behavior="collapse">
        <div class="folder-structure" [ngClass]="{'no-pointer-events' : disableStep1}">
            <app-library-browser class="library-browser" [assetLibrary]="library"
                (folderSelected)="folderselected($event)" #libBrowser [isUpload]="true">
            </app-library-browser>
        </div>
    </sh-pane>

    <div class="upload-asset-div">
        <sh-text class="upload-asset-text">
            Upload Asset in {{ httpService.folder?.name }}
        </sh-text>
        <div class="right-card-div">
            <sh-card class="right-card" card-height="60em">

                <sh-stepper [value]="progressStep" slot="header" id="upload-stepper">
                    <sh-stepper-item label="Select folder and Drop Files" class="no-pointer-events"></sh-stepper-item>
                    <sh-stepper-item label="Provide Information" class="no-pointer-events"></sh-stepper-item>
                    <sh-stepper-item label="Preview" class="no-pointer-events"></sh-stepper-item>
                    <sh-stepper-item label="Confirmation" class="no-pointer-events"></sh-stepper-item>
                </sh-stepper>

                <div *ngIf="progressStep == 1">
                    <input type="file" (change)="onFileSelected($event)" (click)="onInputClick($event)" name="file"
                        id="file" hidden multiple="true" #input>
                    <!-- Showing a alert to user not to upload any coyrighted/proprietary assets to VAL-->
                    <sh-modal id="demo-alert" type='alert' label='Warning' modal-height='auto' modal-width='400px'
                        visible sticky>
                        Proprietary/copyrighted assets should not be uploaded to VAL.
                        <sh-button color='tertiary' slot='footer' label='Cancel' (click)="cancelUploadProcess()">
                        </sh-button>
                        <sh-button color='primary' slot='footer' label='Ok'
                            onclick="document.querySelector('#demo-alert').visible = false"></sh-button>
                    </sh-modal>

                    <!-- Asset name -->
                    <div class="margin-auto" label='Enter Assets Informaion'>
                        <sh-input-text class="width-98" label='Asset Name*'
                            *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile && !disableStep1"
                            [value]="asset.name" (value-changed)="asset.name=$event.target.value" id="tinewAssetName"
                            (blur)="assetNameExists = assetNameControl.invalid && (!httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile) ? false : assetNameCheck(asset.name);assetNameValidation($event.target.value)"
                            [formControl]="assetNameControl" ngDefaultControl name="tinewAssetName" [value]="asset.name"
                            [error]="(assetNameControl.touched || isNextClicked) && (assetNameExists || assetNameControl.invalid || assetNameValidFlg===false)"
                            [disabled]="disableStep1" maxlength="60">
                        </sh-input-text>
                        <sh-tooltip *ngIf="assetNameControl.touched && assetNameControl.hasError('required')"
                            label="Please enter the Asset Name" target="tinewAssetName" placement="bottom-right"
                            variation="short">
                        </sh-tooltip>
                        <sh-tooltip class="assetName-exists-tooltip" *ngIf="assetNameExists"
                            label="The entered asset name already exists. Please enter a different Asset Name"
                            target="tinewAssetName" placement="bottom-right" variation="short">
                        </sh-tooltip>
                        <sh-tooltip *ngIf="!assetNameValidFlg" title="Rules for asset name:"
                            label="Cannot start/end with '-' and '_'. Any other special characters are not allowed."
                            target="tinewAssetName" placement="bottom-right">
                        </sh-tooltip>

                        <sh-input-text class="width-98" label='Asset Name*'
                            *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile && disableStep1"
                            [value]="asset.name" id="tinewAssetName" [formControl]="assetNameControl" ngDefaultControl
                            name="tinewAssetName" [value]="asset.name" disabled>
                        </sh-input-text>
                    </div>
                    <br />
                    <div>
                        <sh-checkbox label='Unity Compatible? (Check this if uploading assetbundles)'
                            id="unityCompatibility" disabled
                            (click)="changeCheckBoxValue(asset.attributes,'compatibilityWithUnity');noPlatformSet=true;threeDfile=null;">
                        </sh-checkbox>

                        <sh-dropdown class="width-98" (value-changed)="platformSelected=$event.target.value"
                            [error]="noPlatformSet && isNextClicked" [value]="platformSelected"
                            *ngIf="asset.attributes.compatibilityWithUnity" label='Platform'>
                            <sh-menu-item *ngFor="let platform of platforms" [label]="platform"
                                (click)="noPlatformSet=false"></sh-menu-item>
                        </sh-dropdown>
                    </div>

                    <div *ngIf="asset.attributes.compatibilityWithUnity" class="upload-area">

                        <ngx-file-drop id="dropFilesBox" dropZoneLabel="Drop Assetbundle here"
                            dropZoneClassName="dropZone" (onFileDrop)="dropAssetbundle($event)"
                            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)"
                            [ngClass]="{ 'no-pointer-events' : disableStep1 }">
                        </ngx-file-drop>

                        <sh-tooltip *ngIf="noFilerError" label="Please upload atleast one 3D file" target="dropFilesBox"
                            placement="bottom-right" variation="short"></sh-tooltip>
                        <!-- <br>
                        <sh-tag *ngIf="assetBundleFile" [label]="assetBundleFile" removable (closed)="remove()">
                        </sh-tag> -->
                    </div>

                    <div *ngIf="!asset.attributes.compatibilityWithUnity" class="upload-area">

                        <ngx-file-drop id="dropFilesBox" dropZoneLabel="Drop files here" dropZoneClassName="dropZone"
                            (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
                            (onFileLeave)="fileLeave($event)" [ngClass]="{ 'no-pointer-events' : disableStep1 }">
                        </ngx-file-drop>

                        <sh-tooltip *ngIf="noFilerError" label="Please upload atleast one 3D file" target="dropFilesBox"
                            placement="bottom-right" variation="short"></sh-tooltip>
                    </div>

                    <br />
                    <sh-button color='primary' id="browseBtn" label='Browse' (click)="input.click()" class="browse">
                    </sh-button><br />

                    <!-- Files area -->
                    <sh-grid>
                        <div columns="4" col-m="4" col-s="12" label='3D Files'>
                            <div label="3D File" class="newCard">
                                <div class="threed-file-text">
                                    <sh-text size='title-1'>3D File</sh-text>
                                </div>
                                <sh-dropdown class="width20em" id="dropdownthreedfile" *ngIf="threeDfile?.relativePath"
                                    label='Quality' [value]=fileQuality
                                    (value-changed)="fileQuality=$event.target.value">
                                    <sh-menu-item id="3h" label='High' active (click)="fileQuality = 'High'">
                                    </sh-menu-item>
                                    <sh-menu-item id="3m" label='Medium' (click)="fileQuality = 'Medium'">
                                    </sh-menu-item>
                                    <sh-menu-item id="3l" label='Low' (click)="fileQuality = 'Low'"></sh-menu-item>
                                </sh-dropdown>
                                <sh-dropdown class="width-20em" id="dropdownthreedfile" *ngIf="threeDfile?.webkitRelativePath === ''"
                                    label='Quality' [value]=fileQuality
                                    (value-changed)="fileQuality=$event.target.value">
                                    <sh-menu-item id="3h" label='High' active (click)="fileQuality = 'High'">
                                    </sh-menu-item>
                                    <sh-menu-item id="3m" label='Medium' (click)="fileQuality = 'Medium'">
                                    </sh-menu-item>
                                    <sh-menu-item id="3l" label='Low' (click)="fileQuality = 'Low'"></sh-menu-item>
                                </sh-dropdown>
                                <strong *ngIf="threeDfile?.relativePath"
                                     class="asset-relative-path">{{ threeDfile?.relativePath }}
                                    <sh-icon button icon="error" class="error-btn"
                                        (click)="deleteThreeDFile(threeDfile)" [disabled]="disableStep1"></sh-icon>
                                </strong>
                                <strong *ngIf="threeDfile?.webkitRelativePath === ''"
                                    class="asset-relative-path">{{ threeDfile.name }}
                                    <sh-icon button icon="error" class="error-btn"
                                        (click)="deleteThreeDFile(threeDfile)" [disabled]="disableStep1"></sh-icon>
                                </strong>
                            </div>

                        </div>

                        <div columns="4" col-m="4" col-s="12" label='Texture Files'>
                            <div label='Texture Files'class="newCard">
                                <div class="threed-file-text">
                                    <sh-text size='title-1'>Texture Files</sh-text>
                                </div>
                                <sh-dropdown class="width-20em" id="dropdowntextture"
                                    *ngIf="threeDfile?.relativePath || texturesFiles.length > 0 || (threeDfile?.name && threeDfile?.name != '')"
                                    label='Quality' [value]=texturequality
                                    (value-changed)="texturequality=$event.target.value">
                                    <sh-menu-item id="h" label='High' active (click)="texturequality = 'High'">
                                    </sh-menu-item>
                                    <sh-menu-item id="m" label='Medium' (click)="texturequality = 'Medium'">
                                    </sh-menu-item>
                                    <sh-menu-item id="l" label='Low' (click)="texturequality = 'Low'"></sh-menu-item>
                                </sh-dropdown>
                                <strong class="asset-relative-path" *ngFor="let item of texturesFiles; let i=index">
                                    <sh-text *ngIf="item?.relativePath?.split('.')[1] != 'zip'">{{ item.relativePath }}
                                        <sh-icon *ngIf="item?.relativePath" button icon="error" class="error-btn"
                                            (click)="deleteFile(item, texturesFiles)" [disabled]="disableStep1">
                                        </sh-icon>
                                    </sh-text>
                                    <sh-text *ngIf="item.webkitRelativePath === ''">{{ item.name }}
                                        <sh-icon button icon="error" class="error-btn"
                                            (click)="deleteFile(item, texturesFiles)" [disabled]="disableStep1">
                                        </sh-icon>
                                    </sh-text>
                                </strong>
                            </div>
                        </div>

                        <div columns="4" col-m="4" col-s="12" label='Readme Files'>
                            <div label="Readme Files" class="newCard">
                                <div class="threed-file-text">
                                    <sh-text size='title-1'>Readme Files</sh-text>
                                </div>
                                <strong class="asset-relative-path" *ngFor="let item of otherFiles; let i=index">
                                    <sh-text *ngIf="!item.name && item?.relativePath?.split('.')[1] != 'zip'">
                                        {{ item.relativePath }}
                                        <sh-icon button icon="error" class="error-btn"
                                            (click)="deleteFile(item, otherFiles)" [disabled]="disableStep1">
                                        </sh-icon>
                                    </sh-text>
                                    <sh-text *ngIf="item.name">{{ item.name }}
                                        <sh-icon button icon="error" class="error-btn"
                                            (click)="deleteFile(item, otherFiles)" [disabled]="disableStep1">
                                        </sh-icon>
                                    </sh-text>
                                </strong>
                            </div>
                        </div>

                    </sh-grid>
                </div>

                <div *ngIf="progressStep == 2">
                    <!-- Primary Contact -->
                    <div>
                        <sh-checkbox label='Are you the Primary Contact?'
                            [active]="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile && isPrimaryContact"
                            (click)="togglePCDiv($event)"
                            [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile">
                        </sh-checkbox>
                        <sh-grid class="primary-contact-grid" *ngIf="showPrimaryContactDiv">
                            <div columns="6" col-m="6" col-s="12">
                                <sh-input-text id="primaryContactName"
                                    *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                                    label='Primary Contact Name*' [value]="asset.attributes.primaryContact.name"
                                    (value-changed)="asset.attributes.primaryContact.name=$event.target.value"
                                    name="primaryContactName" ngDefaultControl
                                    [error]="(primaryContactNameControl.touched || isNextClicked) && primaryContactNameControl.invalid"
                                    [formControl]="primaryContactNameControl"></sh-input-text>

                                <sh-tooltip class="padding-top-0"
                                    *ngIf="primaryContactNameControl.touched && primaryContactNameControl.touched && primaryContactNameControl.invalid"
                                    label="Please enter the Primary Contact Name" target="primaryContactName"
                                    placement="bottom-right" variation="short"></sh-tooltip>

                                <sh-input-text id="primaryContactName" disabled
                                    *ngIf="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                                    label='Primary Contact Name*' [value]="asset.attributes.primaryContact.name"
                                    id="pcName">
                                </sh-input-text>
                            </div>
                            <div columns="6" col-m="6" col-s="12">
                                <sh-input-text id="primaryContactEmail"
                                    *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                                    label='Primary Contact Email Address*'
                                    [value]="asset.attributes.primaryContact.emailId"
                                    (value-changed)="asset.attributes.primaryContact.emailId=$event.target.value"
                                    name="primaryContactEmail" ngDefaultControl
                                    [error]="(primaryContactEmailControl.touched || isNextClicked) && primaryContactEmailControl.invalid"
                                    id="pcEmail" [formControl]="primaryContactEmailControl"></sh-input-text>
                                <sh-tooltip class="padding-top-0"
                                    *ngIf="primaryContactEmailControl.touched && primaryContactEmailControl.hasError('required')"
                                    label="Please enter the Primary Contact Email Id"
                                    target="pcEmail" placement="bottom-right" variation="short"></sh-tooltip>
                                <sh-tooltip class="padding-top-0"
                                    *ngIf="primaryContactEmailControl.touched && (primaryContactEmailControl.hasError('pattern') || primaryContactEmailControl.hasError('email'))"
                                    label="Please enter a valid Primary Contact Email Id"
                                    target="pcEmail" placement="bottom-right" variation="short"></sh-tooltip>

                                <sh-input-text id="primaryContactEmail" disabled
                                    *ngIf="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                                    label='Primary Contact Email Address*'
                                    [value]="asset.attributes.primaryContact.emailId" id="pcEmail">
                                </sh-input-text>
                            </div>
                        </sh-grid>
                    </div>
                    <br />
                    <sh-divider></sh-divider>
                    <br />
                    <sh-grid>
                        <!-- Asset description -->
                        <div columns="4" col-m="4" col-s="8">
                            <sh-text class="asset-details-text">Asset Description</sh-text>
                            <br /><br />
                            <sh-input-text textarea="true" label="Asset Description(max 250 characters)"
                                id="assetDescription" [value]="asset.description"
                                (value-changed)="asset.description=$event.target.value"
                                [formControl]="assetDescriptionControl" ngDefaultControl
                                [error]="(assetDescriptionControl.touched || isNextClicked) && (assetDescriptionControl.invalid)"
                                maxlength="250">
                            </sh-input-text>
                            <sh-tooltip
                                *ngIf="assetDescriptionControl.touched && assetDescriptionControl.hasError('required')"
                                label="Please enter the Asset Description" target="assetDescription"
                                placement="bottom-right" variation="short">
                            </sh-tooltip>
                        </div>
                        <!-- Product status-->
                        <div class="margin-left-10" columns="4" col-m="4" col-s="8">
                            <sh-radio-group>
                                <sh-text class="asset-details-text">Product Status</sh-text>
                                <br />
                                <sh-radio-button
                                    [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                                    label="Not Commercially Ready" id="productstatus1"
                                    [active]="asset.attributes?.productStatus === 0" active
                                    (click)="asset.attributes.productStatus = 0"></sh-radio-button>
                                <sh-radio-button disabled label="Commercially Ready"
                                    [active]="asset.attributes?.productStatus === 1"
                                    (click)="asset.attributes.productStatus = 1" class="no-pointer-events">
                                </sh-radio-button>
                            </sh-radio-group>
                        </div>
                        <!-- Asset visibility-->
                        <div class="margin-left-10" columns="4" col-m="4" col-s="8">
                            <sh-radio-group>
                                <sh-text class="asset-details-text">Accessibility</sh-text>
                                <br />
                                <sh-radio-button
                                    label="Private" id="accessibilitystatus1"
                                    [active]="asset.attributes?.visibility === 0" active
                                    (click)="asset.attributes.visibility = 0">
                                </sh-radio-button>
                                <sh-radio-button label="Public" [active]="asset.attributes?.visibility === 1"
                                    (click)="asset.attributes.visibility = 1">
                                </sh-radio-button>
                              <sh-radio-button label="Restricted" [active]="asset.attributes?.visibility === 2"
                                    (click)="asset.attributes.visibility = 2">
                                </sh-radio-button>
                            </sh-radio-group>
                        </div>
                    </sh-grid>
                    <br />
                    <sh-divider></sh-divider>
                    <br />
                    <!-- Specifications -->
                    <div class="overflow-hidden" label='Specifications' expanded>
                        <sh-text class="asset-details-text">Asset Specifications</sh-text>
                        <div class="assetDetailsGrid">
                            <sh-checkbox label='Rigged' id="cbspecificationrigged"
                                [active]="assetFileSpecifaction.rigged"
                                (click)="changeCheckBoxValue(assetFileSpecifaction,'rigged')"></sh-checkbox>
                            <sh-tooltip class="tooltip"
                                label="In its simplest form, 3D rigging is the process of creating a skeleton for a 3D model so it can move. Especially characters, complex robots (e.g. C-Arms) and medical tables need to be rigged to use them adequately in a 3D animated environment."
                                target="cbspecificationrigged" placement="bottom" title='Rigged'></sh-tooltip>
                            <sh-checkbox label='Animation' id="cbspecificationanimation"
                                [active]="assetFileSpecifaction.animation"
                                (click)="changeCheckBoxValue(assetFileSpecifaction,'animation')"></sh-checkbox>
                            <sh-tooltip class="tooltip"
                                label="Animated 3D objects have attributes added for certain predefined movements. There is no need to add any animation clips at this point (only to better visualize the way the object is animated). Animations for 3D objects shall be used for predefined movements which do not have a certain logic (in code) attached to is. This allows developers to select predefined animation paths for better visualization without a larger user input."
                                target="cbspecificationanimation" placement="bottom" title='Animation'>
                            </sh-tooltip>
                            <!-- <sh-checkbox label='Spin' [active]="assetFileSpecifaction.spin" id="cbspecificationspin" (click)="changeCheckBoxValue(assetFileSpecifaction,'spin')"></sh-checkbox> -->
                            <sh-checkbox label='Movement Logic' [active]="assetFileSpecifaction.movementLogic"
                                id="cbspecificationmovement"
                                (click)="changeCheckBoxValue(assetFileSpecifaction,'movementLogic')" disabled>
                            </sh-checkbox>
                            <sh-tooltip class="tooltip" target="cbspecificationmovement" placement="bottom-right"
                                variation="short"
                                label="Movement Logic : The Movement Logic is the preparation for an interactive object. With a script there is a logical component added to the “rigged and animated” 3D object. This allows a user to access certain standard movement behaviors of the 3D objects. (e.g. the logic of a Kuka-Robot movement according to the individual arms)">
                            </sh-tooltip>
                            <!-- <sh-checkbox label='Interaction' [active]="assetFileSpecifaction.interaction" id="cbspecificationinteraction" (click)="changeCheckBoxValue(assetFileSpecifaction,'interaction')"></sh-checkbox> -->
                            <sh-checkbox label='User Interaction' [active]="assetFileSpecifaction.userInteraction"
                                id="cbspecificationuserInteraction"
                                (click)="changeCheckBoxValue(assetFileSpecifaction,'userInteraction')" disabled>
                            </sh-checkbox>
                            <sh-tooltip target="cbspecificationuserInteraction" placement="bottom-right"
                                variation="short"
                                label="User Interaction : The User Interaction is the combination of a “rigged and animated” 3D-object that has a script attached to it which enables the user to interact with the object with the use of a certain input method (e.g. controller, haptic devices, eyetracking, …). This feature requires the a versioned asset which is stored in the GIT structure.">
                            </sh-tooltip>
                            <!-- <sh-checkbox label='Joystick Interaction' [active]="assetFileSpecifaction.joystickInteraction" id="cbspecificationjoystick" (click)="changeCheckBoxValue(assetFileSpecifaction,'joystickInteraction')"></sh-checkbox> -->
                            <sh-checkbox label='Update Via Git' disabled
                                [active]="assetFileSpecifaction.automaticallyUpdateViaGit"
                                id="cbspecificationupdatedviagit"
                                (click)="changeCheckBoxValue(assetFileSpecifaction,'automaticallyUpdateViaGit')">
                            </sh-checkbox>
                        </div>
                    </div>
                    <br />
                    <sh-divider></sh-divider>
                    <br />
                    <!-- Tags -->
                    <div>
                        <sh-input-text label='Tags for Asset' id="tiassetTags"
                            [disabled]="httpService.newVersionFlag || httpService.newExtensionFlag || httpService.updateAssetFile"
                            (keyup.enter)="addTags($event.target.value.trim());$event.target.value = ''"
                            (keyup.,)="addTags($event.target.value.split(',')[0].trim()); $event.target.value = ''"
                            (blur)="validateTagName($event.target.value.trim())" maxlength="19" [error]="assetTagError">
                        </sh-input-text>
                        <sh-tooltip *ngIf="assetTagError" title="Rules for tag names:"
                            label="Cannot start/end with '-'. Can end with '+'. Cannot start with '++' and '#'. Cannot end with '.'. Any other special characters are not allowed."
                            target="tiassetTags" placement="bottom-right"></sh-tooltip>
                        <br>
                        <div class="tags">
                            <div *ngFor="let tag of assetTagsView; let i = index" class="tags-div">
                                {{tag}}
                                <sh-icon button icon="error" class="tags-error-icon"
                                    *ngIf="!httpService.newVersionFlag && !httpService.newExtensionFlag && !httpService.updateAssetFile"
                                    (click)="removeTag(i)">
                                </sh-icon>
                            </div>
                        </div>
                    </div>
                    <br />
                    <sh-divider></sh-divider>
                    <br />
                    <!-- Provider App Selection -->
                    <div>
                        <sh-text style="font:var(--title-1);display:inline-block;">Provider Application</sh-text>
                        <br/><br/>
                        <sh-dropdown label="Application" mandatory>
                            <sh-menu-item *ngFor="let app of applications;" label="{{app.name}}" [active]="app._id == 'VAL Web App'" (click)="updateApplicationId(app)"></sh-menu-item>
                        </sh-dropdown>
                    </div>
                </div>

                <div *ngIf="progressStep == 3">
                    <sh-grid>
                        <div class="margin-auto" columns="8" col-m="12" col-s="12">
                            <app-three-asset-render [filePath]="httpService.selectedAssetFile?.filePath"
                                [uploadedFiles]="uploadedFiles"
                                [seenBackGround]="httpService.selectedAssetFile?.previewBackgroudColor" #threeViewer
                                [width]="width" [height]="height" (polygonCount)="getPolygonCount($event)" [rotateModel]="rotation">
                            </app-three-asset-render>
                        </div>
                        <div class="margin-left-auto" columns="4" col-m="6" col-s="12">
                            <sh-text size='title-1'>Background Selector</sh-text>
                            <div class="background-selector-div">
                                <div class="color-div-new cursor-pointer" *ngFor="let colour of basicColours"
                                    [ngStyle]="{'background-color': colour }" (click)="selectBackground(colour)"></div>
                            </div>
                            <br />
                            <sh-accordion label='Advanced'>
                                <app-color-picker (backgroundColor)="selectBackground($event)"></app-color-picker>
                            </sh-accordion>
                            <br />
                            <div class="display-flex">
                                <sh-icon icon="snapshot" button (click)="takeSnap()" id="snapshot"></sh-icon>
                                <sh-text class="snapshot-text">Snapshot</sh-text>
                                <input class="display-none" type="file" multiple id="browseFile" #browseFile
                                    (change)="selectPreviewImage($event)">
                                <sh-button shape="pill-m" label="Browse Image" for="browseFile" id="browseImage"
                                    (click)="openBrowseWindow()">
                                </sh-button>
                            </div>
                            <br />
                            <div>
                                <img class="tempImg" alt="img" *ngIf="tempImg.length > 0 " [src]="tempImg" height="100px"/>

                                <img class="selected-preview-img" *ngFor="let url of selectedPreviewImages" [src]="url"
                                    height="100px">
                                <!-- <img alt="img" *ngIf="selectedPreviewImage.length > 0 " [src]="selectedPreviewImage"
                                height="100px" /> -->
                            </div>
                        </div>
                    </sh-grid>
                </div>

                <div *ngIf="progressStep == 4">
                    <sh-text size='title-1'>Please confirm the below details:</sh-text>
                    <br />
                    <div>
                        <sh-grid>
                            <div columns="12">
                                <sh-table>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Asset Name
                                        </sh-table-cell>
                                        <sh-table-cell> {{asset?.name}} </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Asset
                                            Description
                                        </sh-table-cell>
                                        <sh-table-cell class="preview-desc"> {{asset?.description}} </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Primary Contact Name </sh-table-cell>
                                        <sh-table-cell> {{asset?.attributes?.primaryContact?.name}} </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Primary Contact Email id </sh-table-cell>
                                        <sh-table-cell> {{asset?.attributes?.primaryContact?.emailId}} </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Product Status </sh-table-cell>
                                        <sh-table-cell>
                                            {{asset?.attributes?.productStatus == 0 ? 'Not Commercially Ready' : 'Commercially Ready'}}
                                        </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Asset Specifications </sh-table-cell>
                                        <sh-table-cell>
                                            {{viewAssetSpecification.substring(0, viewAssetSpecification.length-2)}}
                                        </sh-table-cell>
                                    </sh-table-row>
                                    <sh-table-row>
                                        <sh-table-cell columns="3"> Tags </sh-table-cell>
                                        <sh-table-cell> {{assetTags.substring(0, assetTags.length-2)}}
                                        </sh-table-cell>
                                    </sh-table-row>
                                </sh-table>
                            </div>
                        </sh-grid>
                    </div>
                </div>

                <br /> <br />
                <!-- buttons -->
                <div class="btn-section" slot='footer'>
                    <sh-button class="buttons" size="md" label="Next" (click)="recordCanvas()" *ngIf="progressStep == 3"
                        [disabled]="disableRecord" id="next-button"></sh-button>
                    <sh-button class="buttons" size="md" label="Next" (click)="nextStep()" *ngIf="progressStep < 4 && progressStep != 3"
                        [disabled]="initialUpload" id="next-button"></sh-button>
                    <sh-button class="buttons" size="md" label="Upload" (click)="upload()" id="button_Upload"
                        *ngIf="progressStep == 4"></sh-button>
                    <sh-button class="buttons" color="secondary" shape="pill-s" label='Previous'
                        (click)="previousStep()" *ngIf="progressStep > 1"></sh-button>
                    <sh-button class="buttons" color="secondary" shape="pill-s" label='Cancel'
                     color="secondary" onclick="document.querySelector('#cancel-modal').visible = true">
                    </sh-button>


                    <sh-modal sticky type='alert' id="cancel-modal" label='Warning' modal-height='200px' modal-width='320px'>
                        Are you sure you want to cancel the upload process?
                        <sh-button color='secondary' slot='footer' label='Cancel' onclick="document.querySelector('#cancel-modal').visible = false"></sh-button>
                        <sh-button slot='footer' label='Yes' (click)="cancelUpload()"></sh-button>
                    </sh-modal>
                    <!-- Progress bar-->
                    <div class="progress-bar-div" *ngIf="initialUpload">
                        <sh-text class="uploading-text">
                            {{ uploadPercentDone < 100 ? 'Uploading' : 'Preparing your Asset' }}... </sh-text>
                        <sh-icon icon="warning" id="warning-icon"> </sh-icon>
                        <sh-progress [value]="uploadPercentDone"></sh-progress>
                        <sh-tooltip label="Warning! Closing the browser will terminate the upload process"
                            target="warning-icon" placement="bottom" variation="short"> </sh-tooltip>
                    </div>
                </div>
                <div slot='footer'>
                    <sh-text class="buttons" *ngIf="initialUpload">Next will be disabled until the upload process
                        completes</sh-text>
                </div>
                <sh-notifications class="notification-card">
                    <sh-notification-item type="confirmation" label="Success" id="success" [visible]="showSuccess">
                        {{showSuccessMessage}}
                    </sh-notification-item>
                </sh-notifications>

            </sh-card>
        </div>
        <div id="overlay" *ngIf="loader">
            <div class="loader">
                <sh-progress-radial size="l" value="{{uploadPercentDone}}" label="{{uploadPercentDone}}%"
                    info='Uploading'>
                </sh-progress-radial>
                <b class="warning">{{ uploadWarningText }}</b>
            </div>
        </div>

        <sh-modal id="unsupported" type='alert' label='Unsupported Files' modal-height='184px' modal-width='320px'>
            <sh-text p>Unsupported format(s): {{unsupportedFiles}}</sh-text>
            <sh-button color='tertiary' slot='footer' label='Close'
                onclick="document.getElementById('unsupported').removeAttribute('visible')"></sh-button>
        </sh-modal>

        <sh-modal id="alreadyPresent" type='alert' label='File present' modal-height='184px' modal-width='320px'>
            <sh-text p>An asset file with thease configuration already present in the current version</sh-text>
            <sh-button color='tertiary' slot='footer' label='Close'
                onclick="document.getElementById('alreadyPresent').removeAttribute('visible')"></sh-button>
        </sh-modal>

        <sh-modal id="unsupported-image" type='alert' label='Unsupported Image' modal-height='184px'
            modal-width='320px'>
            <sh-text p>{{unsupportedImageErrorMessage}}
            </sh-text>
            <sh-button color='tertiary' slot='footer' label='Close'
                onclick="document.getElementById('unsupported-image').removeAttribute('visible')"></sh-button>
        </sh-modal>

        <sh-modal class="text-align-justify" id="3D-file-warning" type='alert' label='Warning' modal-height='222px' modal-width='360px'>
            <sh-text p>Please upload only one 3D object per selection and remove if there are any unrelated texture
                files as they might affect the intended preview of the model.</sh-text>
            <sh-button color='tertiary' slot='footer' label='Close'
                onclick="document.getElementById('3D-file-warning').removeAttribute('visible')"></sh-button>
        </sh-modal>

        <sh-modal class="text-align-justify" id="assetbundle-warning" type='alert' label='Warning' modal-height='222px' modal-width='360px'>
            <sh-text p>Please upload a valid unity compatible assetbundle.</sh-text>
            <sh-button color='tertiary' slot='footer' label='Close'
                onclick="document.getElementById('assetbundle-warning').removeAttribute('visible')"></sh-button>
        </sh-modal>
        <sh-modal id="remixes" type='alert' label='Warning' modal-height='auto' modal-width='320px'>
            <sh-text p>Did you remix uploading asset from any of the existing asset?(If yes, please upload fileinfo.txt
                of the existing asset)</sh-text>
            <sh-button color='primary' slot='footer' label='Yes' (click)="remixModal()"></sh-button>
            <sh-button color='primary' slot='footer' label='No' (click)="notremixModal()"></sh-button>
        </sh-modal>
    </div>

</sh-page>
